module.exports = __webpack_public_path__ + "static/media/yellow.63a3a0a4.jpg";